import { copy, set } from 'cerebral/operators'
import redirect from 'cerebral-module-router/redirect'

import checkLoggedIn from '../actions/checkLoggedIn'
import prepareModuleFieldsForCurrentUser from '../actions/prepareModuleFieldsForCurrentUser'
import setAdminClientHelperForCurrentUser from '../actions/setAdminClientHelperForCurrentUser'
import closeNavigation from './closeNavigation'
import setCommonFieldsForCurrentUser from '../actions/setCommonFieldsForCurrentUser'
import setAggregationFieldsForCurrentUser from '../actions/setAggregationFieldsForCurrentUser'
import setAddressFieldsForCurrentUser from '../actions/setAddressFieldsForCurrentUser'
import resetAllForms from '../factories/resetAllForms'
import validateAllForms from '../factories/validateAllForms'
import isCurrentUserAdmin from '../actions/isCurrentUserAdmin'
import isPreventField from '../factories/isPreventField'
import checkIsAdmin from '../actions/checkIsAdmin'
import isPreventAllClientFields from '../factories/isPreventAllClientFields'
import resetSelectedOptions from '../actions/resetSelectedOptions'
import makeFieldRequired from '../factories/makeFieldRequired'
import isRemoteLogin from '../../client/actions/isRemoteLogin'
import setLocaleForCurrentUser from '../actions/setLocaleForCurrentUser'
import unsetCustomErrorMessages from '../actions/unsetCustomErrorMessages'
import initializeFields from 'modules/app/chains/initializeFields'

export default [
  checkLoggedIn,
  {
    error: [redirect('/login')],
    success: [
      copy('state:client.user', 'state:client.currentUser'),
      setAdminClientHelperForCurrentUser,
      unsetCustomErrorMessages,
      resetSelectedOptions,
      resetAllForms(),
      ...initializeFields,
      setLocaleForCurrentUser,
      setCommonFieldsForCurrentUser,
      setAggregationFieldsForCurrentUser,
      setAddressFieldsForCurrentUser,
      prepareModuleFieldsForCurrentUser,
      isRemoteLogin,
      {
        true: [],
        false: [
          makeFieldRequired(
            'client.registrating.current.newPassword.password',
            false
          ),
          makeFieldRequired(
            'client.registrating.current.newPassword.confirmPassword',
            false
          )
        ]
      },
      checkIsAdmin,
      {
        true: [
          isPreventAllClientFields(false),
          isCurrentUserAdmin,
          {
            true: [
              isPreventField(
                'client.registrating.current.common.validTo',
                true
              ),
              isPreventField(
                'client.registrating.current.common.validFrom',
                true
              )
            ],
            false: [
              isPreventField(
                'client.registrating.current.common.validTo',
                false
              ),
              isPreventField(
                'client.registrating.current.common.validFrom',
                false
              )
            ]
          }
        ],
        false: [isPreventAllClientFields(true)]
      },
      validateAllForms(),
      ...closeNavigation,
      set('state:client.currentPage', 'welcome')
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/user/chains/onPrepareFields.js